import { ReactNode } from 'react'

type BookingPageLayoutProps = {
  header: ReactNode
  /** Full-width controls above the columns (club and session length). */
  toolbar?: ReactNode
  /** Full-width day strip below the toolbar, so the summary starts level with the courts. */
  days?: ReactNode
  courts: ReactNode
  legend: ReactNode
  /** Omitted while the user cannot book: the courts then take the full width. */
  summary?: ReactNode
  bookingSetup?: ReactNode
}

const BookingPageLayout = ({
  header,
  toolbar,
  days,
  courts,
  legend,
  summary,
  bookingSetup,
}: BookingPageLayoutProps) => (
  <>
    {header}
    {toolbar}
    {days && <div className="mb-3">{days}</div>}
    <div className="row g-4 gap-0 align-items-start">
      <div className={`col-12 ${summary ? 'col-xl-9' : ''} order-1 order-md-2 order-xl-1`}>
        {bookingSetup}
        {courts}
        {legend}
      </div>
      {summary && (
        <div className="col-12 col-xl-3 order-2 order-md-1 order-xl-2 mb-4 mb-xl-0">
          {summary}
        </div>
      )}
    </div>
  </>
)

export default BookingPageLayout
